<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ packSelectedOption.title }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      const gameRoles = this.getGame.roles || [];
      const roles = this.checkoutStore.getSelectedRoles || [];
      const packSelectedOptions = gameRoles.filter((role) =>
        roles.includes(role.id)
      );
      return packSelectedOptions;
    },
  },

  methods: {
    renderPrice(option) {
      if (!option) {
        return "";
      }
      if (option.type === "variable") {
        if (option.price_type === 0) {
          return `+${option.price}%`;
        } else if (option.price_type === 1) {
          return `-${option.price}%`;
        }
      }
      if (option.type === "fixed") {
        if (option.price_type === 0) {
          return `+${option.price}$`;
        } else if (option.price_type === 1) {
          return `-${option.price}$`;
        }
      }
      if (option.type === "free") {
        return this.$t("checkout.free");
      }
      return option.price;
    },
  },
  setup() {
    const { getGamePack, getGame } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
